<template>
  <div class="vg-work-order-track">
    <van-steps direction="vertical" :active="0">
      <van-step v-for="step in value"
                :key="step"
                class="vg-work-order-track-step-wrapper">
        <!--                :class="[stepClass(step.name)]">-->
        <div class="vg-work-order-track-step-content">{{ step | stripHtml }}</div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import {Steps, Step} from "vant"

export default {
  name: "VgTextTrack",
  components: {
    "van-steps": Steps,
    "van-step": Step,
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    }
  },
  methods: {
    stepClass(name) {
      if (!name) {
        return null;
      }
      if (name.includes('生成')) {
        return 'generated'
      }
      if (name.includes('匹配')) {
        return 'pending'
      }
      if (name.includes('接单')) {
        return 'received'
      }
      if (name.includes('到岗')) {
        return 'arrived'
      }
      if (name.includes('暂停')) {
        return 'paused'
      }
      if (name.includes('初步')) {
        return 'first-process'
      }
      return null;
    }
  }
}
</script>

<style scoped>
.vg-work-order-track >>> .van-step {
  padding: 0;
}

.vg-work-order-track >>> .van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0;
}

.vg-work-order-track >>> .van-step:last-child .van-step__line {
  border: none;
}

.vg-work-order-track >>> .van-step__line {
  border-left: dashed 2px #B4B4B4;
  width: 0;
  left: -20px;
}

.vg-work-order-track >>> .van-steps.van-steps--vertical {
  padding-left: 35px;
}

.vg-work-order-track >>> .van-step__circle-container {
  top: 11px;
  left: -19px;
}

.vg-work-order-track >>> .van-step__icon::before {
  display: none;
}

.vg-work-order-track-step {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.vg-work-order-track-step-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
}

.vg-work-order-track-step-title-time {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.45);
  line-height: 17px;
}

.vg-work-order-track-step-content {
  word-break: break-word;
  color: #000;
  line-height: 18px;
  margin-bottom: 10px;
}

.vg-work-order-track >>> .van-step:last-child .vg-work-order-track-step-content {
  margin-bottom: 0;
}

.vg-work-order-track-step-image {
  flex: 0 1 auto;
  flex-shrink: 0;
  margin-right: 6px;
}

.vg-work-order-track-step-wrapper >>> .van-step__icon {
  box-sizing: border-box;
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 8px;
  border: solid 2px #4BA9F6;
  background-color: #FFF;
}


.vg-work-order-track-step-wrapper >>> .van-step__circle {
  box-sizing: border-box;
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 8px;
  border: solid 1px #E7E5E7;
  background-color: #FFF;
}

.vg-work-order-track-step-wrapper.pending >>> .van-step__icon {
  background-image: url(@/assets/step/pending_active.svg);
}

.vg-work-order-track-step-wrapper.pending >>> .van-step__circle {
  background-image: url(@/assets/step/pending.svg);
}

.vg-work-order-track-step-wrapper.arrived >>> .van-step__icon {
  background-image: url(@/assets/step/arrived_active.svg);
}

.vg-work-order-track-step-wrapper.arrived >>> .van-step__circle {
  background-image: url(@/assets/step/arrived.svg);
}

.vg-work-order-track-step-wrapper.first-process >>> .van-step__icon {
  background-image: url(@/assets/step/first_process_active.svg);
}

.vg-work-order-track-step-wrapper.first-process >>> .van-step__circle {
  background-image: url(@/assets/step/first_process.svg);
}

.vg-work-order-track-step-wrapper.paused >>> .van-step__icon {
  background-image: url(@/assets/step/paused_active.svg);
}

.vg-work-order-track-step-wrapper.paused >>> .van-step__circle {
  background-image: url(@/assets/step/paused.svg);
}

.vg-work-order-track-step-wrapper.received >>> .van-step__icon {
  background-image: url(@/assets/step/received_active.svg);
}

.vg-work-order-track-step-wrapper.received >>> .van-step__circle {
  background-image: url(@/assets/step/received.svg);
}
</style>
